import React from "react";
import { Droplets } from "lucide-react";

/**
 * App icon component — shows uploaded icon URL or falls back to the Droplets lucide icon.
 * Handles relative URLs by prepending REACT_APP_BACKEND_URL.
 */
function resolveUrl(url) {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}

export function AppIcon({ url, size = 36, className = "" }) {
  const resolved = resolveUrl(url);
  if (resolved) {
    return (
      <img
        src={resolved}
        alt="App icon"
        style={{ width: size, height: size }}
        className={`object-contain rounded-md ${className}`}
        onError={(e) => { e.currentTarget.style.display = "none"; }}
      />
    );
  }
  // Fallback: solid primary with droplets icon
  const inner = Math.max(16, Math.round(size * 0.55));
  return (
    <div
      style={{ width: size, height: size }}
      className={`rounded-md bg-primary flex items-center justify-center ${className}`}
    >
      <Droplets style={{ width: inner, height: inner }} className="text-primary-foreground" />
    </div>
  );
}
